//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Facet.js";
import "../no/Builder.js";
import "../no/SelectNXObjectList.js";
import "../no/SelectObjectList.js";
let d=[[[1,"DestinationObjects",0,"SelectNXObjectList",0],[0,"Direction",1,"Direction",0],[0,"FitConstraints",1,0],[0,"GlobalSearch",1,0],[1,"MobileObjects",0,"SelectNXObjectList",0],[0,"RotateCenter",1,"Point",0],[1,"SourceObjects",0,"SelectNXObjectList",0]],[],[]];
SPLM.Facet.BestFitAlignBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Facet.BestFitAlignBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Facet.BestFitAlignBuilder.ConstraintOptions = Object.freeze({
    "Free" : "Free", "OnlyTranslation" : "OnlyTranslation", "TranslationInPlane" : "TranslationInPlane", "TranslationAlongDirection" : "TranslationAlongDirection", "OnlyRotation" : "OnlyRotation", "RotationAroundPoint" : "RotationAroundPoint", "RotationAroundLine" : "RotationAroundLine", "HoldToPlane" : "HoldToPlane", "HoldToLine" : "HoldToLine"});

export default SPLM;